"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { useMemo, useState } from "react";
import { FiChevronDown, FiSearch } from "react-icons/fi";
import { TbRulerMeasure } from "react-icons/tb";
import MeasurementRecordDialog from "@/components/patient/measurements/record-dialog";
import Button from "@/components/ui/button";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { Dialog, DialogBody, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import Input from "@/components/ui/input";
import type { MeasurementField, MeasurementGroupWithFields } from "@/types/measurement";
import { measurementFieldQueryOptions } from "@/query/settings/measurement-fields";
import { measurementGroupQueryOptions } from "@/query/settings/measurement-groups";
interface AddMeasurementsDialogProps {
  patientId: string;
  eventId?: string;
  children: React.ReactNode;
}
export default function AddMeasurementsDialog(t0) {
  const $ = _c(49);
  const {
    patientId,
    eventId,
    children
  } = t0;
  const [open, setOpen] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedCustomGroup, setSelectedCustomGroup] = useState(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = measurementGroupQueryOptions.list();
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: customGroups
  } = useQuery(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = measurementFieldQueryOptions.list();
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    data: customFields
  } = useQuery(t2);
  let t3;
  bb0: {
    if (!customFields) {
      let t4;
      if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = [];
        $[2] = t4;
      } else {
        t4 = $[2];
      }
      t3 = t4;
      break bb0;
    }
    let t4;
    if ($[3] !== customFields) {
      t4 = customFields.filter(_temp);
      $[3] = customFields;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    t3 = t4;
  }
  const standaloneFields = t3;
  let t4;
  if ($[5] !== search) {
    t4 = search.toLowerCase().trim();
    $[5] = search;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const lowerSearch = t4;
  let t5;
  bb1: {
    if (!customGroups) {
      let t6;
      if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = [];
        $[7] = t6;
      } else {
        t6 = $[7];
      }
      t5 = t6;
      break bb1;
    }
    if (!lowerSearch) {
      t5 = customGroups;
      break bb1;
    }
    let t6;
    if ($[8] !== customGroups || $[9] !== lowerSearch) {
      let t7;
      if ($[11] !== lowerSearch) {
        t7 = g => g.name.toLowerCase().includes(lowerSearch) || (g.description ?? "").toLowerCase().includes(lowerSearch);
        $[11] = lowerSearch;
        $[12] = t7;
      } else {
        t7 = $[12];
      }
      t6 = customGroups.filter(t7);
      $[8] = customGroups;
      $[9] = lowerSearch;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    t5 = t6;
  }
  const filteredGroups = t5;
  let t6;
  bb2: {
    if (!lowerSearch) {
      t6 = standaloneFields;
      break bb2;
    }
    let t7;
    if ($[13] !== lowerSearch || $[14] !== standaloneFields) {
      let t8;
      if ($[16] !== lowerSearch) {
        t8 = f_0 => f_0.name.toLowerCase().includes(lowerSearch) || (f_0.unit ?? "").toLowerCase().includes(lowerSearch);
        $[16] = lowerSearch;
        $[17] = t8;
      } else {
        t8 = $[17];
      }
      t7 = standaloneFields.filter(t8);
      $[13] = lowerSearch;
      $[14] = standaloneFields;
      $[15] = t7;
    } else {
      t7 = $[15];
    }
    t6 = t7;
  }
  const filteredFields = t6;
  const buildSyntheticGroup = _temp2;
  let t7;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = v => {
      setOpen(v);
      if (!v) {
        setSearch("");
      }
    };
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== children) {
    t8 = <DialogTrigger asChild={true}>{children}</DialogTrigger>;
    $[19] = children;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <DialogHeader><DialogTitle>Add Measurements</DialogTitle><DialogDescription>Select the type of measurement you would like to add for this patient.</DialogDescription></DialogHeader>;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  let t10;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <FiSearch size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = e => setSearch(e.target.value);
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== search) {
    t12 = <div className="relative">{t10}<Input placeholder="Search measurements..." value={search} onChange={t11} className="pl-9" /></div>;
    $[24] = search;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== filteredGroups) {
    t13 = filteredGroups.length > 0 && <>{filteredGroups.map(group => <div key={group.id}><Button variant="ghost" className="h-auto w-full justify-start p-4" onClick={() => {
          setSelectedCustomGroup(group);
          setOpen(false);
        }}><div className="flex items-center gap-3"><TbRulerMeasure size={20} className={group.color ? undefined : "text-foreground-secondary"} style={group.color ? {
              color: group.color
            } : undefined} /><div className="text-left"><div className="font-medium">{group.name}</div><div className="text-body text-muted-foreground">{group.description ?? `Record ${group.name.toLowerCase()} measurements`}</div></div></div></Button></div>)}</>;
    $[26] = filteredGroups;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  let t14;
  if ($[28] !== filteredFields || $[29] !== lowerSearch) {
    t14 = filteredFields.length > 0 && <><div className="my-2" /><Collapsible open={lowerSearch ? true : undefined}><CollapsibleTrigger className="flex w-full items-center py-4"><span className="text-overline text-muted-foreground">Individual Fields</span><FiChevronDown className="ml-auto h-3 w-3 text-foreground-secondary transition-transform [[data-state=open]>&]:rotate-180" /></CollapsibleTrigger><CollapsibleContent className="space-y-2">{filteredFields.map(field_0 => <div key={field_0.id}><Button variant="ghost" className="h-auto w-full justify-start p-4" onClick={() => {
              setSelectedCustomGroup(buildSyntheticGroup(field_0));
              setOpen(false);
            }}><div className="flex items-center gap-3"><TbRulerMeasure size={20} className="text-foreground-secondary" /><div className="text-left"><div className="font-medium">{field_0.name}{field_0.unit && <span className="ml-1 text-caption font-normal text-muted-foreground">({field_0.unit})</span>}</div><div className="text-body text-muted-foreground">Record a single {field_0.name.toLowerCase()} value</div></div></div></Button></div>)}</CollapsibleContent></Collapsible></>;
    $[28] = filteredFields;
    $[29] = lowerSearch;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== filteredFields.length || $[32] !== filteredGroups.length || $[33] !== search) {
    t15 = filteredGroups.length === 0 && filteredFields.length === 0 && <div className="py-4 text-center text-body text-muted-foreground">No measurements match "{search}"</div>;
    $[31] = filteredFields.length;
    $[32] = filteredGroups.length;
    $[33] = search;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t12 || $[36] !== t13 || $[37] !== t14 || $[38] !== t15) {
    t16 = <DialogContent className="max-w-md">{t9}<DialogBody><div className="space-y-2 pb-4">{t12}{t13}{t14}{t15}</div></DialogBody></DialogContent>;
    $[35] = t12;
    $[36] = t13;
    $[37] = t14;
    $[38] = t15;
    $[39] = t16;
  } else {
    t16 = $[39];
  }
  let t17;
  if ($[40] !== eventId || $[41] !== patientId || $[42] !== selectedCustomGroup) {
    t17 = selectedCustomGroup && <MeasurementRecordDialog isOpen={!!selectedCustomGroup} onClose={() => setSelectedCustomGroup(null)} group={selectedCustomGroup} patientId={patientId} eventId={eventId} />;
    $[40] = eventId;
    $[41] = patientId;
    $[42] = selectedCustomGroup;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  let t18;
  if ($[44] !== open || $[45] !== t16 || $[46] !== t17 || $[47] !== t8) {
    t18 = <Dialog open={open} onOpenChange={t7}>{t8}{t16}{t17}</Dialog>;
    $[44] = open;
    $[45] = t16;
    $[46] = t17;
    $[47] = t8;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  return t18;
}
function _temp2(field) {
  return {
    id: "",
    name: field.name,
    sortOrder: 0,
    createdDate: "",
    isArchived: false,
    fieldMemberships: [{
      id: "",
      groupId: "",
      fieldId: field.id,
      childGroupId: null,
      sortOrder: 0,
      isRequired: false,
      field,
      childGroup: null
    }]
  };
}
function _temp(f) {
  return !f.isDerived && !f.isArchived;
}